import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { selectAdminToken } from './sessionSlice';
import { processQuestions } from './questionSlice';

export const fetchThemeData = createAsyncThunk(
  'api/fetchThemeData',
  async (
    { themeId = null, isAdmin = false },
    { getState, rejectWithValue }
  ) => {
    try {
      const state = getState();
      const adminToken = selectAdminToken(state);

      console.log("hitting fetchThemeData");
      // #region agent log
      const t8=Date.now();console.log('[DEBUG-875681:H5] fetchThemeData_start',{themeId,ts:t8});
      // #endregion
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/fetchThemeData`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${adminToken}`,
          },
          body: JSON.stringify({
            currentTheme: themeId,
          }),
        }
      );

      if (!response.ok) throw new Error('Network response was not ok');
      const json = await response.json();
      // #region agent log
      console.log('[DEBUG-875681:H5] fetchThemeData_success',{elapsed:Date.now()-t8,ts:Date.now()});
      // #endregion
      return json;
    } catch (error) {
      // #region agent log
      console.log('[DEBUG-875681:H5] fetchThemeData_error',{err:error?.message,ts:Date.now()});
      // #endregion
      return rejectWithValue(error.message);
    }
  }
);

const themeSlice = createSlice({
  name: 'theme',
  initialState: {
    currentTheme: null,
    availableThemes: [],
    status: 'idle',
    error: null,
    data: null,
  },
  reducers: {
    selectTheme: (state, action) => {
      state.currentTheme = action.payload;
    },
    resetTheme: (state) => {
      state.currentTheme = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchThemeData.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchThemeData.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload.data;

        const themeName = action.payload.data.themename;
        state.currentTheme = themeName;

        if (action.meta.arg.isAdmin) {
          state.availableThemes = action.payload.availableThemes || [];
        }
      })
      .addCase(fetchThemeData.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      .addCase(processQuestions.rejected, (_state, action) => {
        console.error('processQuestions failed:', action.payload);
      });
  },
});

export { processQuestions };
export const { selectTheme, resetTheme } = themeSlice.actions;
export default themeSlice.reducer;
